<template>	
    <div>   
        <div class="p-fluid p-formgrid p-grid">            
            <div class="p-col-12 p-md-12">
                <div class="p-field">
                    <label>Empresa</label>
                    <InputText v-model="cnpjSelecionado.cnpjNome" readonly v-if="cnpjSelecionado"/>
                </div>
            </div>
            <div class="p-col-12 p-md-12" v-if="opcaoSincronizarSelecionada != 'SINCRONIZAR_GERAL' && cnpjSelecionado">
                <div class="p-field">
                    <label>Relógio</label>
                    <MultiSelect v-model="relogiosSelecionados" :options="relogios" 
                    optionLabel="descricaoRef" dataKey="numeroSerie"/>			
                </div>
            </div>                    	
            <div class="p-formgroup p-mt-2 p-mb-2 p-col-12">
                <div class="p-field">
                    <label>Opção de Sincronização</label>
                </div>
                <div class="p-field-radiobutton">
                    <RadioButton name="opcaoSinc" value="SINCRONIZAR_GERAL" v-model="opcaoSincronizarSelecionada" @change="selecionarTexto"/>
                    <label>Sincronizar todos os funcionários em todos os equipamentos. Todos os equipamentos.</label>								
                </div>
                <div class="p-field-radiobutton">
                    <RadioButton name="opcaoSinc" value="SINCRONIZAR_GERAL_SELECIONADOS" v-model="opcaoSincronizarSelecionada" @change="selecionarTexto"/>
                    <label>Sincronizar todos os funcionários no(s) equipamento(s) selecionado(s).</label>												
                </div>
                <div class="p-field-radiobutton">
                    <RadioButton name="opcaoSinc" value="IMPORTAR_IMAGENS_FACE" v-model="opcaoSincronizarSelecionada" @change="selecionarTexto"/>	
                    <label>Importar Imagens (digital face) dos funcionários para o IKPonto. Selecione um equipamento.</label>											
                </div>	
                <div class="p-field-checkbox p-mt-5">
                    <Checkbox v-model="forcarSincronizacao" :binary="true"/>
                    <label :class="forcarSincronizacao ? 'p-text-bold' : ''"> 
                        {{ forcarSincronizacao ? 'Forçar Sincronização: exclui todas as tarefas em andamento e reinicia o processo com a opção selecionada.' : 'Forçar Sincronização.'}}
                    </label>
                </div>						
            </div>             
            <br/><br/><br/><br/>
        </div>                                
        <Message severity="warn" :closable="false" v-if="descricaoOpcaoSelecionada">
            <div class="p-pl-2">
                <h3 class="p-text-bold">{{ descricaoOpcaoSelecionada }}</h3>
                <span v-if="detalhesOpcaoSelecionada == 'SINCRONIZAR_GERAL'">
                    <p>Envia todos os funcionários e imagens para cada equipamento no serviço Push.</p>
                    <h3>Atenção! Ações realizadas na seguiante ordem:</h3>
                    <ol>
                        <li>Exclui todos os funcionários e imagens (digital face) em cada equipamento.</li>
                        <li>Cadastra todos os funcioinários em cada equipamento.</li>   
                        <li>Cadastra todas as imagens (digital face) em cada equipamento.</li>                                    
                    </ol>
                </span>
                <span v-else-if="detalhesOpcaoSelecionada == 'SINCRONIZAR_GERAL_SELECIONADOS'">
                    <p>Envia todos os funcionários e imagens para cada equipamento selecionado no serviço Push.</p>
                    <h3>Atenção! Ações realizadas na seguiante ordem:</h3>
                    <ol>
                        <li>Exclui todos os funcionários e imagens (digital face) em cada equipamento.</li>
                        <li>Cadastra todos os funcioinários em cada equipamento.</li>   
                        <li>Cadastra todoas as imagens (digital face) em cada equipamento.</li>                                    
                    </ol>
                </span>
                <span v-else>
                    <p>Envia todas as imagens cadastradas no <strong>equipamento selecionado</strong> para o IKPonto.</p>                                
                </span>
            </div>
        </Message>
    </div>		
</template>

<script>
import RelogioPontoService from '@/service/RelogioPontoService.js';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	relogioPontoService: null,     
    data() {
        return {            
			opcoesSincronizar: [
                { descricao: 'Sincronizar todos os funcionários em todos os equipamentos', valor: 'SINCRONIZAR_GERAL' },
                { descricao: 'Sincronizar todos os funcionários no(s) equipamento(s) selecionado(s)', valor: 'SINCRONIZAR_GERAL_SELECIONADOS' },
                { descricao: 'Importar Imagens (digital face) dos funcionários para o IKPonto.', valor: 'IMPORTAR_IMAGENS_FACE' }
            ],	
            forcarSincronizacao: false,
            opcaoSincronizarSelecionada: null,
            relogios: [],
			relogiosSelecionados: null,		
            descricaoOpcaoSelecionada: '',
            detalhesOpcaoSelecionada: '',
            cnpjSelecionado: null,
            callbackAposCrirarTarefas: null,
            respostaTarefasPushAsync: { erro: false, temPushAsync: false }
        }        
    },
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),	  
        /**
         * 
         */
        setCnpjSelecionado(cnpj) {
            this.cnpjSelecionado = cnpj;
            this.listarRelogios();
        },  
        /**
         * 
         */
        criarTarefa(callbackAposCrirarTarefas) {
            this.respostaTarefasPushAsync.erro = false;
            this.respostaTarefasPushAsync.temPushAsync = false;
            this.callbackAposCrirarTarefas = callbackAposCrirarTarefas;
            if(!this.opcaoSincronizarSelecionada || !this.cnpjSelecionado) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(!this.cnpjSelecionado) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(this.opcaoSincronizarSelecionada == 'SINCRONIZAR_GERAL') {
                if(this.forcarSincronizacao) {
                    this.excluirTarefas(() => {
                        this.criarTarefaSincronismoTodos();
                    });
                } else {
                    this.criarTarefaSincronismoTodos();
                }
                return;
            }
            let selecionados = [];
            if(this.relogiosSelecionados) {
                selecionados = [...this.relogiosSelecionados];
            }           
            if(this.opcaoSincronizarSelecionada == 'SINCRONIZAR_GERAL_SELECIONADOS') {
                const fc = () => {
                    if(this.relogios.length == selecionados.length) {                
                        this.criarTarefaSincronismoTodos();                   
                    } else {                        
                        this.criarTarefaSincronismoSelecionados(selecionados);   
                    }
                }
                if(this.forcarSincronizacao) {
                    this.excluirTarefas(() => { fc(); });
                } else {
                    fc();
                }
                return;
            }
            if(this.opcaoSincronizarSelecionada == 'IMPORTAR_IMAGENS_FACE') {          
                if(selecionados.length == 0) {
                    exibirMensagemSis(this, 'Selecione o equipamento', true);
                    return;
                }
                if(selecionados.length > 1) {
                    exibirMensagemSis(this, 'Selecione somente um equipamento', true);
                    return;
                }
                if(this.forcarSincronizacao) {
                    this.excluirTarefas(() => {
                        this.criarTarefaImportarImagens(selecionados[0]);
                    });
                } else {
                    this.criarTarefaImportarImagens(selecionados[0]);
                }
            }
        },
        /**
         * 
         */
        excluirTarefas(callback) {            
			this.relogioPontoService.excluirTarefas(this.cnpjSelecionado.id)
			.then(() => {					
				setTimeout(() => {
                    callback();
                }, 500);						
			})
			.catch(erro => {
                exibirMensagem(this, erro);
            });	
        },
        /**
		* 
		*/
		criarTarefaSincronismoTodos() {	       
			let requisicao = {				
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.criarTarefaSincronismoTodos(requisicao)
			.then(resp => {					
				exibirMensagem(this, resp);
				this.pesquisarRelogiosNaSincronizacaoComPushAsync(this.relogios);						
			})
			.catch(erro => {
                exibirMensagem(this, erro);
                this.respostaTarefasPushAsync.erro = true;
                this.callbackAposCrirarTarefas(this.respostaTarefasPushAsync);
            });			
        },
		/**
		* 
		*/
        criarTarefaSincronismoSelecionados(selecionados) {     
			let requisicao = {				
                relogiosSelecionados: selecionados,
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.criarTarefaSincronismoSelecionados(requisicao)
			.then(resp => {					
				exibirMensagem(this, resp);
				this.pesquisarRelogiosNaSincronizacaoComPushAsync(selecionados);							
			})
			.catch(erro => {
                exibirMensagem(this, erro);
                this.respostaTarefasPushAsync.erro = true;
                this.callbackAposCrirarTarefas(this.respostaTarefasPushAsync);
            });			
        },
        /**
         * 
         */
        criarTarefaImportarImagens(relogioPonto) {            
			let requisicao = {				
                relogioPonto: relogioPonto,
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.criarTarefaImportarImagens(requisicao)
			.then(resp => {					
				exibirMensagem(this, resp);
                this.pesquisarRelogiosNaSincronizacaoComPushAsync([relogioPonto]);					
			})
			.catch(erro => {
                exibirMensagem(this, erro);
                this.respostaTarefasPushAsync.erro = true;
                this.callbackAposCrirarTarefas(this.respostaTarefasPushAsync);
            });			
        },
        /**
         * 
         */
        pesquisarRelogiosNaSincronizacaoComPushAsync(relogios) {
            let temRelogioPushAsync = false;
            relogios.forEach(r => {
                if(r.tipoServico === 'Push Async') {
                   temRelogioPushAsync = true;
                }
            });            
            this.respostaTarefasPushAsync.erro = false;    
            this.respostaTarefasPushAsync.temPushAsync = temRelogioPushAsync; 
            this.callbackAposCrirarTarefas({...this.respostaTarefasPushAsync});     
        },
        /**
		 * 
		 */
		listarRelogios() {			
			if(this.cnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
			this.relogioPontoService.listarMonitoramentoPushPorCnpj(this.cnpjSelecionado.id)
			.then(resp => {	
                 resp.data.forEach(r => {                           
                    r['descricaoRef'] = r.modelo + ' / ' + r.numeroSerie + ' / ' + r.localInstalacao;
                    this.relogios.push(r);
                });
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
        /**
         * 
         */
        selecionarTexto() {
            this.opcoesSincronizar.forEach(op => {
                if(op.valor == this.opcaoSincronizarSelecionada) {
                    this.descricaoOpcaoSelecionada = op.descricao;
                    this.detalhesOpcaoSelecionada = op.valor;
                }
            });
        }	
	},
	created() {
        this.cnpjSelecionado = null;
		this.relogioPontoService = new RelogioPontoService();
	}
}
</script>
